import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";

import useFlashToasts from "../single-page/hooks/useFlashToasts.js";
import CustomerAccess from "./CustomerAccess.jsx";

// A tela inicial do sistema é a de acesso do Customer (CPF ou CNPJ + código
// por e-mail), full-screen — design da Parvi (Figma "Parvi — Sistema"): logo +
// card sobre foto, sem header nem footer. A antiga landing pública e as
// telas de auth do User foram desativadas e removidas em 2026-10-10
// (histórico no git) — o operador entra pelo Devise ERB em /admin/users/sign_in.
export default function Public({ flash = {} }) {
  useFlashToasts(flash);

  return (
    <BrowserRouter>
      <Routes>
        {/* Raiz → tela de acesso do Customer */}
        <Route path="/"        element={<CustomerAccess />} />
        <Route path="/:locale" element={<CustomerAccess />} />

        {/* Aliases mantidos para compatibilidade com links antigos. */}
        <Route path="/access" element={<Navigate to="/" replace />} />
        <Route path="/public" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster richColors closeButton position="top-right" duration={8000} />
    </BrowserRouter>
  );
}
